export const ADD_LISTINGS_LABEL = "Add listings";
